import { render, staticRenderFns } from "./upload-images.vue?vue&type=template&id=39f21870"
import script from "./upload-images.vue?vue&type=script&lang=js"
export * from "./upload-images.vue?vue&type=script&lang=js"
import style0 from "./upload-images.vue?vue&type=style&index=0&id=39f21870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports